import { useDebouncedSearch } from "@/lib/hooks/use-debounced-search";
import { BsSearch } from "react-icons/bs";
import { Input } from "../ui";
import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";
import { FiSearch } from "react-icons/fi";

interface SearchInputProps {
  currentSearch?: string;
  onSearch?: (value: string) => void;
  className?: string;
  variant?: "default" | "dashboard";
}

export function SearchInput({
  currentSearch = "",
  onSearch,
  className,
  variant,
}: SearchInputProps) {
  const [inputValue, setInputValue] = useState(currentSearch);
  const { debouncedSearch } = useDebouncedSearch({
    onSearch: (value) => onSearch?.(value),
  });

  useEffect(() => {
    setInputValue(currentSearch);
  }, [currentSearch]);

  return variant === "dashboard" ? (
    <div className={cn("relative w-1/5", className)}>
      <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary w-5 h-5" />
      <Input
        type="text"
        placeholder="Search"
        className="pl-10 w-full border-none placeholder:text-muted-dark font-pt-sans text-lg"
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
          debouncedSearch?.(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            debouncedSearch?.(inputValue);
          }
        }}
      />
    </div>
  ) : (
    <div className={cn("relative w-48 h-14", className)}>
      <BsSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground w-4 h-4" />
      <Input
        type="text"
        placeholder="Search crops"
        className="pl-10 w-full h-14"
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
          debouncedSearch?.(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            debouncedSearch?.(inputValue);
          }
        }}
      />
    </div>
  );
}
